import {Mapper} from '@s-ui/domain'

const STEPS = {
  LANDING: 'LANDING',
  USER_FORM: 'USER_FORM',
  VEHICLE_FORM: 'VEHICLE_FORM',
  VEHICLE_SELECT: 'VEHICLE_SELECT'
}

/**
 * @implements Mapper
 */
export class TrackingLandingInstantOfferTestMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
    this._STEPS = STEPS
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   */
  map({page: _page, culture, data}) {
    const {origin, searchResultsCount, step} = data

    let page = _page
    const trackingData = {}

    if (step === STEPS.VEHICLE_SELECT) {
      page = 'LANDING_INSTANT_OFFER_TEST_VEHICLE_SELECT'
      trackingData.search_result_number = searchResultsCount
    }

    if (step === STEPS.VEHICLE_FORM) {
      page = 'LANDING_INSTANT_OFFER_TEST_VEHICLE_FORM'
      trackingData.hit_information = origin
    }

    if (step === STEPS.USER_FORM) {
      page = 'LANDING_INSTANT_OFFER_TEST_USER_FORM'
      if (!origin) trackingData.hit_information = 'matricula es mi coche'
    }

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
